import Vue from 'vue'
import Router from 'vue-router'

import setTitle from '../utils/setTitle'
import * as baseMethods from '../utils/baseMethod'
import {Axios} from '../utils/Axios'
import store from '../store/index'
import { customerUsers } from '@/services/api.index'
import { Loading } from 'element-ui'

import Index from '@/views/index'
import Compose from '@/views/tec/compose'
import Compose1 from '@/views/tec/compose_1'
import Compose2 from '@/views/tec/compose_2'
import Compose3 from '@/views/tec/compose_3'
import GenCompose from '@/views/tec/gen_compose'
import Sanger from '@/views/tec/sanger'
import Summary from '@/views/summary/index'
import SummaryAbout from '@/views/summary/about'
import SummaryDevelop from '@/views/summary/develop'
import SummaryGlobal from '@/views/summary/global'
import SummaryAchievement from '@/views/summary/achievement'
import SummaryContact from '@/views/summary/contact'
import News from '@/views/news/index'
import News1 from '@/views/news/index1'
import NewsDetails from '@/views/news/details'
import NewsMarket from '@/views/news/market'
import NewsDetails1 from '@/views/news/details1'
import Resource from '@/views/resource/index'
import TsingMap from '@/views/TsingMap/index'
import SummaryJoinUs from '@/views/summary/join_us'
import Recruit from '@/views/recruit'
import QPCR from '@/views/tec/qPCR.vue'
import RDNA from '@/views/tec/rDNA.vue'
import SNP from '@/views/tec/SNP.vue'
import SSR from '@/views/tec/SSR.vue'
import Specific from '@/views/tec/specific.vue'
import Extraction from '@/views/tec/extraction.vue'
import CellFree from '@/views/tec/cell_free.vue'
import Identification from '@/views/tec/identification.vue'
import Vector from '@/views/tec/vector.vue'
import DNAExtraction from '@/views/tec/DNA_extraction.vue'
import DNABarcode from '@/views/tec/DNA_barcode.vue'
import PCR from '@/views/tec/PCR.vue'
import ITS from '@/views/tec/ITS.vue'
import Mitochondrial from '@/views/tec/mitochondrial.vue'
import Whole_plasmid from '@/views/tec/Whole_plasmid.vue'
import Amplicon from '@/views/tec/amplicon.vue'
import Prokaryotic from '@/views/tec/prokaryotic.vue'
import Eukaryotic from '@/views/tec/eukaryotic.vue'
import Fungal from '@/views/tec/fungal.vue'
import Resequencing from '@/views/tec/resequencing.vue'
import CircRNA from '@/views/tec/circRNA.vue'
import LncRNA from '@/views/tec/lncRNA.vue'
import SmallRNA from '@/views/tec/smallRNA.vue'
import Macrogenome from '@/views/tec/macrogenome.vue'
import TargetSequencing from '@/views/tec/target_sequencing.vue'
import HumanSequencing from '@/views/tec/human_sequencing.vue'
import DeNovo from '@/views/tec/de_novo.vue'
import FullLength from '@/views/tec/full_length.vue'
import WholeTransciptome from '@/views/tec/whole_transciptome.vue'
import WholeExome from '@/views/tec/whole_exome.vue'
import Bacterial from '@/views/tec/bacterial.vue'
import T15KL from '@/views/intel/T15KL.vue'
import Wh5 from '@/views/intel/wh5.vue'
import Mp2500 from '@/views/intel/mp2500.vue'
import Mc15k from '@/views/intel/mc15k.vue'
import Compose12 from '@/views/intel/compose12.vue'
import Compose24 from '@/views/intel/compose24.vue'
import Compose192 from '@/views/intel/compose192.vue'
import Compose768 from '@/views/intel/compose768.vue'
import Tm30 from '@/views/intel/tm30.vue'
import Device1 from '@/views/intel/device_1.vue'
import Device2 from '@/views/intel/device_2.vue'
import Device3 from '@/views/intel/device_3.vue'
import Am096 from '@/views/intel/am096.vue'
import AKTA from '@/views/intel/AKTA.vue'
import R01 from '@/views/intel/R01.vue'
import CTT from '@/views/intel/CTT.vue'
import DHFSYS from '@/views/intel/DHFSYS.vue'
import Mini7ks from '@/views/intel/mini_7ks.vue'
import RT20 from '@/views/intel/RT20.vue'
import Metal from '@/views/intel/metal.vue'
import MIX2500 from '@/views/intel/MIX2500.vue'
import MiniCentrifuge from '@/views/intel/mini_centrifuge.vue'
import Products from '@/views/products/index.vue'
import ProductsDetails from '@/views/products/details.vue'
import Search from '@/views/search.vue'
import Login from '@/views/login.vue'
import Register from '@/views/register.vue'
import Reset from '@/views/reset.vue'
import Forget from '@/views/forget.vue'
import AccountStatus from '@/views/account_status.vue'
import OrderSanger from '@/views/tec/order_sanger.vue'
import OrderPrimer from '@/views/tec/order_primer.vue'
import PrimerConfirm from '@/views/tec/primer_confirm.vue'
import OrderGene from '@/views/tec/order_gene.vue'
import GeneConfirm from '@/views/tec/gene_confirm.vue'
import SuccessSubmit from '@/views/tec/success_submit.vue'
import ProductsChart from '@/views/products/chart.vue'
import ProductsChartConfirm from '@/views/products/chart_confirm.vue'
import User from '@/views/user/index.vue'
import UserIndex from '@/views/user/children/index.vue'
import UserCourse from '@/views/user/children/course.vue'
import UserMolecular from '@/views/user/children/molecular.vue'
import UserSanger from '@/views/user/children/sanger.vue'
import fastNGS from '@/views/user/children/fastNGS.vue'
import UserSangerRecord from '@/views/user/children/sanger_record.vue'
import UserPrimer from '@/views/user/children/primer.vue'
import UserGene from '@/views/user/children/gene.vue'
import UserProject from '@/views/user/children/project.vue'
import UserMall from '@/views/user/children/mall.vue'
import UserIntegralGet from '@/views/user/children/integral_get.vue'
import UserIntegralExchange from '@/views/user/children/integral_exchange.vue'
import UserProductDetail from '@/views/user/product_details.vue'
import OrderIntergal from '@/views/user/order_intergal.vue'
import UserProjectDetails from '@/views/user/project_details.vue'
import UserSangerDetails from '@/views/user/sanger_details.vue'
import fastNGSDetails from '@/views/user/fastNGS_details.vue'
import UserMolecularDetails from '@/views/user/molecular_details.vue'
import UserSangerSearch from '@/views/user/sanger_search.vue'
import UserCollection from '@/views/user/Collection_details.vue'
import UserComment from '@/views/user/comment_details.vue'
import UserConsult from '@/views/user/consult_details.vue'
import arrivalNotice from '@/views/user/arrivalNotice.vue'
import UserPrimerDetails from '@/views/user/primer_details.vue'
import UserGeneDetails from '@/views/user/gene_details.vue'
import download from '@/views/download.vue'
//新版页面新增路由
import UserPrimerSearch from '@/views/user/primer_search.vue'
import Conventional_molecular_project from '@/views/products/Conventional_molecular_project'
import Fixed from '@/views/products/Fixed-mutation'
import PCR1 from '@/views/products/PCR_cloning'
import Plasmid from '@/views/products/Plasmid_Extraction'
import subclone from '@/views/products/subclone'
import Products1 from '@/views/products/Products1'
import Products2 from '@/views/products/Products2'
import Gene from '@/views/products/Gene'
import Gene_regulation from '@/views/products/Gene_regulation'
import Gene_editing from '@/views/products/Gene_editing'
import Gene_interference from '@/views/products/Gene_interference'

import Gene_SNP from '@/views/products/Gene_SNP'
import Methylation_detection from '@/views/products/Methylation_detection'
import Cell_Line_Construction from '@/views/products/Cell_Line_Construction'
import Protein_expression from '@/views/products/Protein_expression'
import Virus_packaging from '@/views/Virus/Virus_packaging.vue'
import Lentivirus_packaging from '@/views/Virus/Lentivirus_packaging.vue'
import Adenovirus_packaging from '@/views/Virus/Adenovirus_packaging.vue'
import Adeno_associated_virus from '@/views/Virus/Adeno_associated_virus.vue'
import life_sciences from '@/views/equipment/life_sciences.vue'
import Biological from '@/views/Biological_manufacturing/Biological.vue'
import GeneFactory from '@/views/gene-factory'
import generation_sequencing from '@/views/tec/1.5_generation_sequencing.vue'
import Genome_sequencing from '@/views/products/Genome_sequencing.vue'
import Microbial_sequencing from '@/views/products/Microbial_sequencing.vue'
import Transcriptome_sequencing from '@/views/products/Transcriptome_sequencing.vue'
import Chemical_Reagents from '@/views/equipment/Chemical_Reagents.vue'
import Instruments_equipment from '@/views/equipment/Instruments_equipment.vue'
import IntegratedScheme from '@/views/equipment/IntegratedScheme.vue'
import Modified_synthesis from '@/views/equipment/Modified_synthesis.vue'
import Molecular_reagent from '@/views/molecular_reagents/Molecular_reagent.vue'
import DNA_tiqu from '@/views/products/DNA_tiqu.vue'
import Tvector_cloning from  '@/views/products/Tvector_cloning.vue'
import BSP_Sequencing from  '@/views/products/BSP_Sequencing.vue'
import Plant from '@/views/tec/Plant_animal_resequencing.vue'
import Viral from '@/views/tec/Viral_genome_sequencing.vue'
import sgRNA from '@/views/products/sgRNA_Synthesis.vue'
import shRNA_lentiviral from '@/views/products/shRNA_lentiviral.vue'
import siRNA_miRNA_synthesis from '@/views/products/siRNA_miRNA_synthesis.vue'
import shRNA_library from '@/views/products/shRNA_library_construction.vue'
import circRNA from '@/views/products/circRNA_overexpression.vue'
import ASO from '@/views/products/ASO_antisense.vue'
import sgRNA_plasmid_construction from '@/views/products/sgRNA_plasmid_construction.vue'
import sgRNA_library_construction from '@/views/products/sgRNA_library_construction.vue'
import Cas9_sgRNA_library_construction from "../views/products/Cas9_sgRNA_library_construction"
import CRISPRi_CRISPRa_Applications from '@/views/products/CRISPRi_CRISPRa_Applications.vue'
import RecombinantCellsProteinExpression from '@/views/products/recombinant-cells-protein-expression'
import mycoupon from '@/views/user/children/My_Coupons.vue'
import bind from '@/views/user/children/Binding_Coupons.vue'
import messagePushTip from '@/views/messagePushTip/index'
import confirmExchangeSuccess from "@/views/products/confirmExchangeSuccess.vue"
import confirmExchange from '@/views/mobile/confirmExchange/index'
import EmailLink from '@/views/EmailLink/index.vue'
import amplificationPrimerDesign from '@/views/EmailLink/amplificationPrimerDesign.vue'
import ImproveInformation from "@/views/APPLink/ImproveInformation.vue"

import Pseudovirus from "../views/Virus/Pseudovirus";
// 基因合成新增二级页面
import mRNA_Poly_page from '@/views/products/mRNA_Poly_page'
import ssDNA_page from '@/views/products/ssDNA_page'
import standard_page from '@/views/products/standard_page'
import large_fragments_page from '@/views/products/large_fragments_page'
import rapid_page from '@/views/products/rapid_page'
import pETgene_page from '@/views/products/pETgene_page'
import DNA_fragments_page from '@/views/products/DNA_fragments_page'


// 分享外联页面引入,无跳转
import MemberAuth from '@/views/share/member-auth'
import ConfirmOrder from '@/views/share/confirm-order'
import ConfirmPopup from '@/views/share/confirm-popup'
import GeneGraph from '@/views/share/gene-graph'
// 云工具
import Tools from '@/views/tools'
import SeqStitching from '@/views/tools/seqStitching'
import SeqPeakPlots from '@/views/tools/seqPeakPlots'
import SeqExportReport from '@/views/tools/seqExportReport'
import SeqSNPAnalysis from '@/views/tools/seqSNPAnalysis'

// import MIndex from '@/views/mobile/index'
// import MBind from '@/views/mobile/bind'
// import MAccountStatus from '@/views/mobile/account_status'
import mobileRoutes from './mobile'
import {loginShopDelete} from '../services/api.index'
import * as baseMthods from "../utils/baseMethod";

import { getAuthCode } from '@/services/api.index'

// let commonIndex = Index
// let commonLogin = Login
// let commonAccountStatus = AccountStatus
// eslint-disable-next-line no-unused-vars
let isMobile = false
if (navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
)) {
  isMobile = true
  // commonIndex = MIndex
  // commonLogin = MBind
  // commonAccountStatus = MAccountStatus
}

Vue.use(Router)
// 云工具相关路径
const toolRoutes = [
  {
    path: '/tools',
    // path: '',
    component: Tools,
    meta: {
      title: '云工具',
    },
    children: [
      {
        path: '/tools/seqStitching',
        name: 'seqStitching',
        component: SeqStitching,
        meta: {
          show: true,
          title: '序列拼接'
        }
      },
      {
        path: '/tools/seqPeakPlots',
        name: 'seqPeakPlots',
        component: SeqPeakPlots,
        meta: {
          show: true,
          title: '峰图（ab1转pdf）'
        }
      },
      {
        path: '/tools/seqExportReport',
        name: 'seqExportReport',
        component: SeqExportReport,
        meta: {
          show: true,
          title: '导出ab1分析报告'
        }
      },
      {
        path: '/tools/seqSNPAnalysis',
        name: 'seqSNPAnalysis',
        component: SeqSNPAnalysis,
        meta: {
          show: true,
          title: 'SNP分析'
        }
      },
    ],
  }
]
const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '擎科生物',
      requireAuth: true,
      content: {
        title: window.location.hostname.includes('www.tsingke.com.cn')?'擎科生物 - 专业基因合成 | 引物合成 | 测序服务提供商':'',
        keywords: window.location.hostname.includes('www.tsingke.com.cn')?'擎科 测序 基因合成':'',
        description: window.location.hostname.includes('www.tsingke.com.cn')?'擎科生物是一家合成生物学国家高新技术企业，提供基因合成、引物合成、基因检测、蛋白表达、抗体等服务，以及试剂、仪器等产品。我们高质量、定制化的解决方案，助力您的科研与产业发展。':''
      }
    }
  },
  {
    path: '/summary',
    component: Summary,
    meta: {
      title: '擎科概况',
      content: {
        title: window.location.hostname.includes('www.tsingke.com.cn')?'公司简介 - 擎科生物':'',
        keywords: window.location.hostname.includes('www.tsingke.com.cn')?'擎科生物 基因合成 引物合成':'',
        description: ''
      }
    },
    children: [{
      path: '/summary/about',
      name: 'SummaryAbout',
      component: SummaryAbout,
      meta: {
        title: '擎科简介',
        content: {
          title: window.location.hostname.includes('www.tsingke.com.cn')?'公司简介 - 擎科生物':'',
          keywords: window.location.hostname.includes('www.tsingke.com.cn')?'擎科生物 基因合成 引物合成':'',
          description: window.location.hostname.includes('www.tsingke.com.cn')?'北京擎科生物科技股份有限公司（Beijing Tsingke Biotech Co., Ltd.）是一家领先的合成生物学高新技术企业，提供高效、高品质的基因合成和引物合成服务。依托自主研发的关键试剂和设备，致力于推动生物医药、生物制造等领域的科研与产业化。擎科荣获多项国家级荣誉，拥有300余项自主知识产权，是您可信赖的基因合成合作伙伴。':''
        }
      }
    },
    //  {
    //   path: '/summary/develop',
    //   name: 'SummaryDevelop',
    //   component: SummaryDevelop,
    //   meta: {
    //     title: '发展历程'
    //   }
    // },
    {
      path: '/summary/global',
      name: 'SummaryGlobal',
      component: SummaryGlobal,
      meta: {
        title: '全国布局'
      }
    }, {
      path: '/summary/achievement',
      name: 'SummaryAchievement',
      component: SummaryAchievement,
      meta: {
        title: '发展成果'
      }
    }, {
      path: '/summary/contact',
      name: 'SummaryContact',
      component: SummaryContact,
      meta: {
        title: '联系我们'
      }
    }]
  }, {
    path: '/news',
    component: News,
    meta: {
      title: '擎科新闻'
    }
  }, {
    path: '/news/index1',
    component: News1,
    meta: {
      title: '市场活动'
    }
  },{
    path: '/news/details/:id',
    name: 'NewsDetails',
    component: NewsDetails,
    meta: {
      title: '资讯详情'
    }
  },
  {
    path: '/products/Products1',
    name: 'Products1',
    component: Products1,
    meta: {
      title: '产品及服务',
      content: {
        title: '值得信赖的基因合成、引物合成、病毒包装服务供应商 — 擎科生物',
        keywords:'基因合成 引物合成 病毒包装',
        description:'擎科生物作为合成生物学领域的领军企业，可为客户提供基因合成、引物合成、病毒包装等产品和服务。我们拥有专业的研发技术和全产业链生产平台，为您的科研项目提供高效、全面的解决方案。联系我们，开启基因组学研究的新篇章!'
      }
    },
    children: [
      {
        path: '/equipment/Chemical_Reagents',
        name: 'Chemical_Reagents',
        component: Chemical_Reagents,
        meta: {
          show:true,
          title: '化学试剂',
          content: {
            title: '迪纳兴科化学试剂 | 核酸药物原料供应商 - 擎科生物',
            keywords: '迪纳兴科 化学试剂 CPG',
            description: '擎科生物专注于核酸药物原料的研发和生产，提供包括DNA合成试剂、合成单体、修饰单体及CPG等高质量产品，助力精准医疗。我们的产品已通过ISO9001认证，出口至多个国家。联系我们了解更多关于迪纳兴科化学试剂的信息。'
          }
        }
      },
      {
        path: '/equipment/IntegratedScheme',
        name: 'IntegratedScheme',
        component: IntegratedScheme,
        meta: {
          show:true,
          title: '合成原料/设备/工艺 一站式解决方案'
        }
      },
      {
        path: '/equipment/Modified_synthesis',
        name: 'Modified_synthesis',
        component: Modified_synthesis,
        meta: {
          show:true,
          title: '寡核苷酸修饰',
          content: {
            title: '高品质修饰引物/探针合成服务 - 擎科生物',
            keywords: 'qPCR 荧光标记 引物探针',
            description: '擎科生物在北京和苏州分别建立了GMP-Like级别的Oligo合成实验室——梓熙生物，并获得了ISO 13485认证，其中苏州梓熙生物专注于修饰引物合成，可提供包括qPCR探针、NGS引物探针、荧光修饰、生物素修饰、氨基修饰等200余种修饰/标记引物合成服务，具备μg至kg级别的合成能力，为基因研究、微生物检测、体外诊断等领域提供高品质原料。'
          }
        },
        children: [
          {
            path: '/tec/compose1',
            name: 'Compose1',
            component: Compose1,
            meta: {
              invisible:true,
              title: 'DNA合成',
              content: {
                title: 'DNA合成服务 | 高纯度、100%序列准确性 - 擎科生物',
                keywords:'引物 引物合成 DNA合成',
                description:'擎科提供高品质DNA合成服务。采用先进技术合成的DNA引物，严格质控，保证100%序列准确性和高纯度，全国多地24h实验室，引物次日达!'
              }
            }
          },
          {
            path: '/tec/compose3',
            name: 'Compose3',
            component: Compose3,
            meta: {
              invisible:true,
              title: 'RNA合成',
              content: {
                title: 'RNA合成服务 | 专业siRNA、sgRNA合成 - 擎科生物',
                keywords: 'siRNA sgRNA RNAi',
                description: '擎科生物在北京和苏州分别建立了GMP-Like级别的Oligo合成实验室——梓熙生物，并获得了ISO 13485认证，其中北京梓熙生物专注于RNA合成，可提供siRNA、sgRNA、miRNA和ASO等多种类型类型，具备μg至kg级别的合成能力，为基因功能研究、核酸药物发现生产、RNAi与CRISPR等领域提供高品质原料。'
              }
            },
            children: []
          },
        ]
      },
      {
        path: '/tec/compose',
        name: 'Compose',
        component: Compose,
        meta: {
          show:true,
          title: '寡核苷酸合成',
          content: {
            title: '引物合成服务 | 常规引物、修饰引物、RNA合成 - 擎科生物',
            keywords: '引物 寡核苷酸 引物设计',
            description: '擎科生物集原料、合成设备、合成技术和服务于一体，形成了完整的产业链。实验室覆盖近20个城市，为大学、科研院所、医院、政府机构和医药诊断公司的科研和研发产品提供安全、可靠、经济的全品类寡核苷酸产品。'
          }
        },children: [
          {
            path: '/tec/compose2',
            name: 'Compose2',
            component: Compose2,
            meta: {
              invisible:true,
              title: '修饰引物/探针合成',
              content: {
                title: '科研级与GMP级的DNA/RNA合成服务 — 擎科生物',
                keywords: 'qpcr Taqman探针 qpcr引物',
                description: '擎科生物提供GMP级别修饰引物/探针合成服务，涵盖Taqman探针、qPCR引物等多种产品，配备先进技术和洁净生产车间，符合ISO 13485质量标准，为全球分子诊断企业、基因检测企业等提供定制化、高标准的核心原料。'
              }
            },
            children: []
          },
        ]
      },
      {
        path: '/tec/gen_compose',
        name: 'GenCompose',
        component: GenCompose,
        meta: {
          show: true,
          title: '基因合成',
          content: {
            title: '领先的基因合成服务商 - 擎科生物',
            keywords:'基因合成 定点突变 ssDNA',
            description:'擎科生物配备基因合成智能化生产线，可为您提供最长达200 kb的高质量、快速的基因合成服务，满足生命科学研究、生物制药、生物育种、生物制造、基因存储等领域的需求。'
          }
        },children: [
          // {
          //   path: '/tec/gen_compose',
          //   name: 'GenCompose',
          //   component: GenCompose,
          //   meta: {
          //     invisible:true,
          //     title: '基因合成'
          //   }
          // },
          {
            path: '/products/Fixed-mutation',
            name: 'Fixed',
            component: Fixed,
            meta: {
              invisible:true,
              title: '定点突变'
            }
          },
          {
            path: '/products/PCR_cloning',
            name: 'PCR1',
            component: PCR1,
            meta: {
              invisible:true,
              title: 'PCR克隆'
            }
          },
          {
            path: '/products/Plasmid_Extraction',
            name: 'Plasmid',
            component: Plasmid,
            meta: {
              invisible:true,
              title: '质粒抽提'
            }
          },
          {
            path: '/products/subclone',
            name: 'subclone',
            component: subclone,
            meta: {
              invisible:true,
              title: '亚克隆'
            }
          },
          {
            path: '/products/mRNA_Poly_page',
            name: 'mRNA_Poly_page',
            component: mRNA_Poly_page,
            meta: {
              invisible:true,
              title: 'mRNA Poly(A) 基因合成',
              content: {
                title: 'mRNA poly(A) 基因合成服务：满足您的mRNA药物研发需求 | 擎科生物',
                keywords: 'mRNA合成 mRNA疫苗 mRNA技术',
                description: '擎科生物提供快速稳定的mRNA poly(A) 基因合成服务，采用创新合成工艺和自主研发的高GC序列扩增试剂，成功率100%。专为mRNA药物研发企业设计，提升您的mRNA合成、mRNA疫苗开发及mRNA技术研究的效率。立即访问我们的网站了解更多信息，助力您的项目！'
              }
            }
          },
          {
            path: '/products/ssDNA_page',
            name: 'ssDNA_page',
            component: ssDNA_page,
            meta: {
              invisible:true,
              title: '长单链DNA合成'
            }
          },
          {
            path: '/products/standard_page',
            name: 'standard_page',
            component: standard_page,
            meta: {
              invisible:true,
              title: '标准基因合成',
              content: {
                title: '标准基因合成服务 - 擎科生物',
                keywords: '质粒构建 密码子优化 基因组',
                description: '擎科生物提供高交付率、高准确率的标准基因合成服务。同时，我们提供免费密码子优化和160+免费载体，帮助您快速实现质粒构建需求。联系我们获得更多信息！'
              }
            }
          },
          {
            path: '/products/large_fragments_page',
            name: 'large_fragments_page',
            component: large_fragments_page,
            meta: {
              invisible:true,
              title: '大片段及基因组合成',
              content: {
                title: '高效大片段及基因组合成 | 擎科生物',
                keywords: '人工合成 DNA组装 定制基因',
                description: '擎科生物提供领先的大片段及基因组合成服务，专注于人工合成和DNA组装。我们的高性价比的基因合成服务，合成长度可达200 kb，适用于生命科学研究、生物制药、生物育种、生物制造、基因存储等领域。我们的专业团队确保高效、准确的基因组装解决方案，助力科研和生物技术创新。'
              }
            }
          },
          {
            path: '/products/rapid_page',
            name: 'rapid_page',
            component: rapid_page,
            meta: {
              invisible:true,
              title: '快速基因合成',
              content: {
                title: '快速基因合成 | 高效DNA合成与提取技术 | 擎科生物',
                keywords: 'DNA合成 DNA提取技术 基因构建',
                description: '擎科生物提供领先的快速基因合成服务，快至5个自然日交付项目，节约您的合成时间，加快您的实验进程。同时我们结合先进的DNA合成和DNA提取技术，专注于高效基因构建。我们的专家团队确保每个项目的精确性和可靠性，助力您的科研和生物技术突破。'
              }
            }
          },
          {
            path: '/products/pETgene_page',
            name: 'pETgene_page',
            component: pETgene_page,
            meta: {
              invisible:true,
              title: 'pETgene基因合成',
              content: {
                title: 'pETgene基因合成服务 | 优化大肠杆菌表达系统的首选 | 擎科生物',
                keywords: '原核表达 大肠杆菌表达载体 基因表达载体构建',
                description: '擎科生物推出的pETgene基因合成服务，结合群体遗传学与基因表达多因素优化技术，专为大肠杆菌表达系统设计，提供高效原核蛋白表达解决方案。立即访问我们的网站，了解更多关于原核表达、大肠杆菌表达载体和基因表达载体构建的信息，提升您的研究效率！'
              }
            }
          },
          {
            path: '/products/DNA_fragments_page',
            name: 'DNA_fragments_page',
            component: DNA_fragments_page,
            meta: {
              invisible:true,
              title: 'DNA片段合成',
              content: {
                title: 'DNA片段合成服务 | 擎科生物',
                keywords: 'DNA合成 DNA片段 分子克隆',
                description: '擎科生物提供高效的DNA片段合成服务，适用于基因合成、改造及多个基因构建体的高通量筛选。我们的专业服务涵盖DNA合成、DNA片段及分子克隆需求，助力科研人员在分子生物学研究中取得更佳成果。'
              }
            }
          },
        ]
      },

      {
        path: '/products/Conventional_molecular_project',
        name: 'Conventional_molecular_project',
        component: Conventional_molecular_project,
        alwaysShow: false,
        meta: {
          show:true,
          title: '其他服务项目',
          content: {
            title: '高效精准的分子生物学实验服务 - 擎科生物',
            keywords: '分子生物学实验 PCR扩增 SNP检测',
            description: '擎科生物提供专业的分子生物学实验服务，包括DNA提取、PCR扩增、SNP检测等一站式解决方案。我们的先进设备和科研团队确保实验结果的精准无误，助力您的科研进程。'
          }
        },
        children: [
          {
            path: '/tec/DNA_extraction',
            name: 'DNAExtraction',
            component: DNAExtraction,
            meta: {
              invisible:true,
              title: 'DNA提取'
            }
          },
          {
            path: '/tec/PCR',
            name: 'PCR',
            component: PCR,
            meta: {
              invisible:true,
              title: 'PCR扩增'
            }
          },
          {
            path: '/tec/SSR',
            name: 'SSR',
            component: SSR,
            meta: {
              invisible:true,
              title: 'SSR/STR检测'
            }
          },
          {
            path: '/tec/SNP',
            name: 'SNP',
            component: SNP,
            meta: {
              invisible:true,
              title: 'SNP检测'
            }
          },
          {
            path: '/products/DNA_tiqu',
            name: 'DNA_tiqu',
            component: DNA_tiqu,
            meta: {
              invisible:true,
              title: '提取+扩增+测序'
            }
          },
          {
            path: '/products/Tvector_cloning',
            name: 'Tvector_cloning',
            component: Tvector_cloning,
            meta: {
              invisible:true,
              title: 'T 载体克隆'
            }
          },
          {
            path: '/products/BSP_Sequencing',
            name: 'BSP_Sequencing',
            component: BSP_Sequencing,
            meta: {
              invisible:true,
              title: '甲基化检测（BSP测序）'
            }
          },
          {
            path: '/tec/specific',
            name: 'Specific',
            component: Specific,
            meta: {
              invisible:true,
              title: '特定基因检测'
            }
          },
          {
            path: '/tec/qPCR',
            name: 'QPCR',
            component: QPCR,
            meta: {
              invisible:true,
              title: '荧光定量PCR'
            }
          },
          {
            path: '/tec/rDNA',
            name: 'RDNA',
            component: RDNA,
            meta: {
              invisible:true,
              title: '菌种鉴定'
            }
          },
          {
            path: '/tec/identification',
            name: 'Identification',
            component: Identification,
            meta: {
              invisible:true,
              title: '细胞系鉴定'
            }
          },
        ]
      },
      {
        path: '/Virus/Virus_packaging',
        name: 'Virus_packaging',
        component: Virus_packaging,
        meta: {
          show:true,
          title: '病毒包装',
          content: {
            title: '病毒包装服务专家 | 擎科生物',
            keywords: '慢病毒包装 基因敲入 基因编辑',
            description: '擎科生物提供高效的病毒包装服务，包括慢病毒、腺病毒、和腺相关病毒的包装等。我们专注于基因编辑，如基因敲入、基因敲除等，利用先进的载体技术，实现外源基因的持久表达和高效感染多种细胞类型，助力基因治疗和疫苗研究。'
          }
        },
        children: [
          {
            path: '/Virus/Lentivirus_packaging',
            name: 'Lentivirus_packaging',
            component: Lentivirus_packaging,
            meta: {
              invisible:true,
              title: '慢病毒包装'
            },
          },{
            path: '/Virus/Adenovirus_packaging',
            name: 'Adenovirus_packaging',
            component: Adenovirus_packaging,
            meta: {
              invisible:true,
              title: '腺病毒包装'
            },
          },{
            path: '/Virus/Adeno_associated_virus',
            name: 'Adeno_associated_virus',
            component: Adeno_associated_virus,
            meta: {
              invisible:true,
              title: '腺相关病毒'
            },
          },
        ]
      },
      {
        path: '/products/Gene',
        name: 'Gene',
        component: Gene,
        meta: {
          show:true,
          title: '基因检测',
          content: {
            title: '高效精准的测序服务 | 擎科生物',
            keywords: '测序 sanger测序 转录组测序',
            description: '擎科生物提供高质量的基因检测服务，包括Sanger测序、高通量测序等多项测序服务。利用先进技术与高质量服务保证满足基因组、转录组等多组学测序要求，助力人类疾病研究与生物学领域的突破。'
          }
        },
        children: [
          {
            path: '/sanger',
            name: 'Sanger',
            component: Sanger,
            meta: {
              invisible:true,
              title: 'Sanger测序',
              content: {
                title: 'Sanger测序服务 | 测序找擎科速必达，上班前出结果 - 擎科生物',
                keywords: 'Sanger测序 测序 质粒测序',
                description: '擎科生物已为上万家科研院所、医院及工业企业提供数千万次Sanger测序服务。实验室配备百余台3730XL遗传分析仪，已实现自动化、智能化生产全覆盖，确保高测序成功率和准时性；建立了“速必达、测必成、疑必解”三大Sanger测序服务新标准。'
              }
            },
            children:[]
          },
          {
            path: '/products/Genome_sequencing',
            name: 'Genome_sequencing',
            component: Genome_sequencing,
            meta: {
              invisible:true,
              title: '基因组测序',
              content: {
                title: '专业快速基因组测序服务 | 擎科生物',
                keywords: '快速全基因组测序 全外显子测序 基因组文库',
                description: '擎科生物提供全面的基因组测序服务，包括快速全基因组测序、全外显子组测序、基因组文库构建等。依托高通量测序技术和专业的生物信息学分析团队，我们致力于为个体或群体的遗传变异、基因功能研究提供有力支持。'
              }
            },
            children: [
              {
                path: '/tec/human_sequencing',
                name: 'HumanSequencing',
                component: HumanSequencing,
                meta: {
                  invisibles:true,
                  title: '人全基因组测序'
                }
              },
              {
                path: '/tec/whole_exome',
                name: 'WholeExome',
                component: WholeExome,
                meta: {
                  invisibles:true,
                  title: '人全外显子组测序'
                }
              },
              {
                path: '/tec/Plant_animal_resequencing',
                name: 'Plant',
                component: Plant,
                meta: {
                  invisibles:true,
                  title: '动植物重测序'
                }
              },
              {
                path: '/tec/mitochondrial',
                name: 'Mitochondrial',
                component: Mitochondrial,
                meta: {
                  invisibles:true,
                  title: '线粒体/叶绿体精细图测序'
                }
              },
              {
                path: '/tec/Viral_genome_sequencing',
                name: 'Viral',
                component: Viral,
                meta: {
                  invisibles:true,
                  title: '病毒基因组测序'
                }
              },
            ]
          },
          {
            path: '/products/Transcriptome_sequencing',
            name: 'ngs_second/transcriptome_sequencing',
            component: Transcriptome_sequencing,
            meta: {
              invisible:true,
              title: '转录组测序'
            },
            children: [
              {
                path: '/tec/whole_transciptome',
                name: 'WholeTransciptome',
                component: WholeTransciptome,
                meta: {
                  invisibles:true,
                  title: '全转录组测序'
                }
              },
              {
                path: '/tec/prokaryotic',
                name: 'Prokaryotic',
                component: Prokaryotic,
                meta: {
                  invisibles:true,
                  title: '原核转录组测序'
                }
              },
              {
                path: '/tec/eukaryotic',
                name: 'Eukaryotic',
                component: Eukaryotic,
                meta: {
                  invisibles:true,
                  title: '真核转录组测序'
                }
              },
              {
                path: '/tec/full_length',
                name: 'FullLength',
                component: FullLength,
                meta: {
                  invisibles:true,
                  title: '全长转录组测序'
                }
              },
              {
                path: '/tec/lncRNA',
                name: 'lncRNA',
                component: LncRNA,
                meta: {
                  invisibles:true,
                  title: 'lncRNA测序'
                }
              },
              {
                path: '/tec/smallRNA',
                name: 'SmallRNA',
                component: SmallRNA,
                meta: {
                  invisibles:true,
                  title: 'small RNA测序'
                }
              },
            ]
          },
          {
            path: '/products/Microbial_sequencing',
            name: 'Microbial_sequencing',
            component: Microbial_sequencing,
            meta: {
              invisible:true,
              title: '微生物测序'
            },
            children: [
              {
                path: '/tec/ITS',
                name: 'ITS',
                component: ITS,
                meta: {
                  invisibles:true,
                  title: '16S/18S/ITS扩增子测序(二代)'
                }
              },
              {
                path: '/tec/amplicon',
                name: 'Amplicon',
                component: Amplicon,
                meta: {
                  invisibles:true,
                  title: '16S/18S/ITS扩增子测序(三代)'
                }
              },
              {
                path: '/tec/bacterial',
                name: 'Bacterial',
                component: Bacterial,
                meta: {
                  invisibles:true,
                  title: '细菌基因组测序'
                }
              },
              {
                path: '/tec/fungal',
                name: 'Fungal',
                component: Fungal,
                meta: {
                  invisibles:true,
                  title: '真菌基因组测序'
                }
              },
              {
                path: '/tec/macrogenome',
                name: 'Macrogenome',
                component: Macrogenome,
                meta: {
                  invisibles:true,
                  title: '宏基因组测序'
                }
              },
            ]
          },
          {
            path: '/tec/1.5_generation_sequencing',
            name: '1.5_generation_sequencing',
            component: generation_sequencing,
            meta: {
              invisible:true,
              title: 'Fast NGS',
              content: {
                title: 'Fast NGS技术 | 高效测序服务解决方案 | 擎科生物',
                keywords: '二代测序服务 载体构建服务 全质粒测序',
                description: '擎科生物的Fast NGS技术兼具一代测序的准确性和二代测序的高通量低成本，采用创新算法，无需引物即可精确分析1 kb以上长片段。适用于PCR产物和质粒DNA样本，覆盖100 bp-30 kb的全序列检测需求。提供高效全质粒测序及小基因组测序服务，助力您的分子生物学研究。'
              }
            },
            children: []
          },

        ]
      },
      {
        path: '/products/Gene_regulation',
        name: 'Gene_regulation',
        component: Gene_regulation,
        meta: {
          show: true,
          title: '基因调控',
          content: {
            title: '专业基因调控服务 - 擎科生物',
            keywords: '基因编辑 基因过表达 分子互作',
            description: '擎科生物提供全面的基因表达调控服务，包括基因编辑、基因干扰、基因过表达、分子互作等。我们致力于为基因功能研究提供优质解决方案，推动精准医疗发展。'
          }
        },
        children: [
          {
            path: '/products/Gene_editing',
            name: 'Gene_editing',
            component: Gene_editing,
            meta: {
              invisible: true,
              title: '基因编辑'
            },
            children: [

            ]
          },
          {
            path: '/products/sgRNA_Synthesis',
            name: 'sgRNA_Synthesis',
            component: sgRNA,
            meta: {
              invisibles:true,
              title: 'sgRNA合成',
              content: {
                title: '基因编辑工具--sgRNA合成服务 | 擎科生物',
                keywords: 'sgRNA 基因编辑 crispr',
                description: '擎科生物提供高质量的sgRNA合成服务，结合先进的CRISPR基因编辑技术。我们采用化学合成的方式直接合成全长sgRNA，确保高效转染和低脱靶风险。我们的服务涵盖sgRNA设计、合成及验证，确保高效精准的基因编辑，为您的研究提供可靠支持。'
              }
            }
          },
          {
            path: '/products/sgRNA_plasmid_construction',
            name: 'sgRNA_plasmid_construction',
            component: sgRNA_plasmid_construction,
            meta: {
              invisibles:true,
              title: 'sgRNA质粒构建'
            }
          },
          {
            path: '/products/sgRNA_library_construction',
            name: 'sgRNA_library_construction',
            component: sgRNA_library_construction,
            meta: {
              invisibles:true,
              title: 'sgRNA文库构建'
            }
          },
          {
            path: '/products/Cas9_sgRNA_library_construction',
            name: 'Cas9_sgRNA_library_construction',
            component: Cas9_sgRNA_library_construction,
            meta: {
              invisibles:true,
              title: 'Cas9 sgRNA文库构建服务'
            }
          },
          {
            path: '/products/CRISPRi_CRISPRa_Applications',
            name: 'CRISPRi_CRISPRa_Applications',
            component: CRISPRi_CRISPRa_Applications,
            meta: {
              invisibles:true,
              title: 'CRISPRa/CRISPRi应用'
            }
          },
          {
            path: '/Virus/Pseudovirus',
            name: 'Pseudovirus',
            component: Pseudovirus,
            meta: {
              invisibles: true,
              title: '假病毒'
            }
          },
          {
            path: '/products/Cell_Line_Construction',
            name: 'Cell_Line_Construction',
            component: Cell_Line_Construction,
            meta: {
              invisibles: true,
              title: '细胞株构建'
            }
          },
          {
            path: '/products/Gene_interference',
            name: 'Gene_interference',
            component: Gene_interference,
            meta: {
              invisible:true,
              title: '基因干扰'
            },
            children: [
            ]
          },
          {
            path: '/products/shRNA_lentiviral',
            name: 'shRNA_lentiviral',
            component: shRNA_lentiviral,
            meta: {
              invisibles:true,
              title: 'shRNA慢病毒质粒构建'
            }
          },
          {
            path: '/products/siRNA_miRNA_synthesis',
            name: 'shRNA_lentiviral',
            component: siRNA_miRNA_synthesis,
            meta: {
              invisibles:true,
              title: 'siRNA/miRNA合成',
              content: {
                title: 'siRNA/miRNA合成服务：实现精准基因干扰和基因沉默 | 擎科生物',
                keywords: '基因干扰 RNAi 基因沉默',
                description: '擎科生物提供专业的siRNA/miRNA合成服务，合成速度快至3天，并且提供3保1套餐，年套餐设计量超过12000次，成功率＞98%，更有多种专用修饰类型，提供双链纯度质检服务，具备核酸药级别的合成规模，为您开展基因功能研究与药物研发保驾护航'
              }
            }
          },
          {
            path: '/products/shRNA_library_construction',
            name: 'shRNA_library_construction',
            component: shRNA_library,
            meta: {
              invisibles:true,
              title: 'shRNA文库构建'
            }
          },
          {
            path: '/products/ASO_antisense',
            name: 'ASO_antisense',
            component: ASO,
            meta: {
              invisibles:true,
              title: 'ASO反义寡核苷酸'
            }
          },

          {
            path: '/products/circRNA_overexpression',
            name: 'circRNA_overexpression',
            component: circRNA,
            meta: {
              invisible:true,
              title: 'circRNA过表达质粒构建'
            }
          },


          {
            path: '/products/Methylation_detection',
            name: 'Methylation_detection',
            component: Methylation_detection,
            meta: {
              invisible:true,
              title: '甲基化检测'
            }
          },
          // {
          //   path: '/products/Gene_SNP',
          //   name: 'Gene_SNP',
          //   component: Gene_SNP,
          //   meta: {
          //     invisible:true,
          //     title: '基因Pannel定制及SNP分型'
          //   }
          // },
          {
            path: '/products/Protein_expression',
            name: 'Protein_expression',
            component: Protein_expression,
            meta: {
              invisible:true,
              title: '蛋白表达'
            }
          },
        ]
      },
      {
        path: '/products/recombinant-cells-protein-expression',
        name: 'RecombinantCellsProteinExpression',
        component: RecombinantCellsProteinExpression,
        meta: {
          show: true,
          title: '快速重组细胞及蛋白表达',
          content: {
            title: '高效蛋白表达、重组抗体快速交付服务 - 擎科生物',
            keywords: '蛋白表达 原核表达 重组抗体',
            description: '擎科生物提供高质量的快速重组抗体与蛋白表达服务。我们的一站式解决方案快至1周交付，具有表达量高、通量高、交付率高等特点，助力您的研究。'
          }
        }
      }
    ]
  },
  {
    path: '/molecular-reagent',
    name: 'molecular_reagent_single',
    component: Molecular_reagent,
    meta: {
      show: false,
      title: '生物试剂',
      scrollTop: false,
      content: {
        title: '达领 | 高品质生物试剂供应商 - 擎科生物',
        keywords: '达领 感受态 试剂',
        description: '擎科生物提供多种高品质生物试剂，涵盖核酸纯化、逆转录、qPCR、PCR、核酸电泳、克隆、感受态细胞、蛋白、仪器设备等系列产品。我们致力于为科研和工业生产提供丰富的试剂和优质服务。'
      }

    }
  },
  {
    path: '/equipment/Instruments_equipment',
    name: 'Instruments_equipment',
    component: Instruments_equipment,
    meta: {
      show:true,
      title: '合成设备'
    },
    children: [
      {
        path: '/intel/device_1',
        name: 'Device1',
        component: Device1,
        meta: {
          invisible:true,
          title: '合成仪'
        },
        children: [
          {
            path: '/intel/compose12',
            name: 'Compose12',
            component: Compose12,
            meta: {
              invisibles:true,
              title: '合成仪-12通道'
            }
          }, {
            path: '/intel/compose24',
            name: 'Compose24',
            component: Compose24,
            meta: {
              invisibles:true,
              title: '合成仪-24通道'
            }
          }, {
            path: '/intel/compose192',
            name: 'Compose192',
            component: Compose192,
            meta: {
              invisibles:true,
              title: '合成仪-192通道',
              content: {
                keywords: '192通道合成仪  768通道合成仪',
                description: '自主研发的DNA合成仪'
              }
            }
          }, {
            path: '/intel/compose768',
            name: 'Compose768',
            component: Compose768,
            meta: {
              invisibles:true,
              title: '合成仪-768通道',
              content: {
                keywords: '192通道合成仪  768通道合成仪',
                description: '自主研发的DNA合成仪'
              }
            }
          },
        ]
      },
      {
        path: '/intel/device_2',
        name: 'Device2',
        component: Device2,
        meta: {
          invisible:true,
          title: '合成配套设备'
        },
        children: [
          {
            path: '/intel/am096',
            name: 'Am096',
            component: Am096,
            meta: {
              invisibles:true,
              title: '氨解仪'
            }
          },
          {
            path: '/intel/AKTA',
            name: 'AKTA',
            component: AKTA,
            meta: {
              invisibles:true,
              title: '纯化仪'
            }
          }, {

            path: '/intel/R01',
            name: 'R01',
            component: R01,
            meta: {
              invisibles:true,
              title: '溶解仪'
            }
          },{

            path: '/intel/CTT',
            name: 'CTT',
            component: CTT,
            meta: {
              invisibles:true,
              title: '离心浓缩仪'
            }
          },
          {

            path: '/intel/DHFSYS',
            name: 'DHFSYS',
            component: DHFSYS,
            meta: {
              invisibles:true,
              title: '防腐蚀转轮除湿系统'
            }
          },
        ]
      },
      {
        path: '/intel/device_3',
        name: 'Device3',
        component: Device3,
        meta: {
          invisible:true,
          title: '小型实验设备'
        }
      },
    ]
  },
  {
    path: '/equipment/life_sciences',
    name: 'life_sciences',
    component: life_sciences,
    meta: {
      title: '生命科学研究设备及原料',
      content: {
        title: '领先的生命科学研究设备及试剂供应商 - 擎科生物',
        keywords: '仪器设备 生物试剂 化学试剂',
        description: '擎科生物是一家致力于合成生物学领域的自主创新企业，提供包括合成系列设备、化学试剂和生物试剂在内的合成生物学设备及原材料，为客户提供全方位的合成生物学解决方案。'
      }
    },
    children: [
      // {
      //   path: '/equipment/Modified_synthesis',
      //   name: 'Modified_synthesis',
      //   component: Modified_synthesis,
      //   meta: {
      //     show:true,
      //     title: '修饰合成'
      //   },
      //   children: [
      //     {
      //       path: '/tec/compose2',
      //       name: 'Compose2',
      //       component: Compose2,
      //       meta: {
      //         invisible:true,
      //         title: '修饰引物/探针合成'
      //       },
      //       children: []
      //     },
      //     {
      //       path: '/tec/compose3',
      //       name: 'Compose3',
      //       component: Compose3,
      //       meta: {
      //         invisible:true,
      //         title: 'RNA合成'
      //       },
      //       children: []
      //     },
      //   ]
      // },

      {
        path: '/equipment/Molecular_reagent',
        name: 'Molecular_reagent',
        component: Molecular_reagent,
        meta: {
          show: true,
          title: '生物试剂',
          scrollTop: true,
          content: {
            title: '达领 | 高品质生物试剂供应商 - 擎科生物',
            keywords: '达领 感受态 试剂',
            description: '擎科生物提供多种高品质生物试剂，涵盖核酸纯化、逆转录、qPCR、PCR、核酸电泳、克隆、感受态细胞、蛋白、仪器设备等系列产品。我们致力于为科研和工业生产提供丰富的试剂和优质服务。'
          }
        },
        children: [
          {
            path: '/products/details/:id',
            name: 'ProductsDetails',
            component: ProductsDetails,
            meta: {
              invisible:true,
              title: '生物试剂详情'
            }
          },
        ]
      },
      // {
      //   path: '/equipment/Chemical_Reagents',
      //   name: 'Chemical_Reagents',
      //   component: Chemical_Reagents,
      //   meta: {
      //     show:true,
      //     title: '化学试剂'
      //   }
      // },
      // {
      //   path: '/equipment/IntegratedScheme',
      //   name: 'IntegratedScheme',
      //   component: IntegratedScheme,
      //   meta: {
      //     show:true,
      //     title: '合成原料/设备/工艺 一站式解决方案'
      //   }
      // },

    ]
  },
  {
    path: '/Biological_manufacturing/Biological',
    name: 'Biological',
    component: Biological,
    meta: {
      title: '生物制造CXO'
    }
  },
  {
    path: '/gene-factory',
    name: 'GeneFactory',
    component: GeneFactory,
    meta: {
      title: '基因工厂',
      content: {
        title: '擎科基因工厂 合成要素自主的平台型企业 — 擎科生物',
        keywords: '擎科生物 基因合成 全产业链',
        description: '擎科生物作为基因工厂的提出者和践行者，形成了合成要素自主的全产业链生产平台，实现稳定高效、自动化的基因合成智能生产。了解我们的产品与服务：引物合成、基因合成、病毒包装、基因检测等，助力您在研究领域取得突破。'
      }
    }
  },
  {
    path: '/market',
    name: 'NewsMarket',
    component: NewsMarket,
    meta: {
      title: '营销内容'
    }
  },
  {
    path: '/news/details1/:id',
    name: 'NewsDetails1',
    component: NewsDetails1,
    meta: {
      title: '营销内容详情'
    }
  },{
    name: 'resource',
    path: '/resource',
    component: Resource,
    meta: {
      title: '资源中心',
      content: {
        title: '资源中心 - 擎科生物',
        keywords: '基因合成 蛋白表达 资源中心',
        description: '擎科生物针对您所需的基因合成、蛋白表达等合成服务，提供常用技术服务和高分文献手册等资料，满足您的各种研究及订购需求。'
      }
    }
  },{
    path: '/TsingMap',
    component: TsingMap,
    meta: {
      title: '站点地图'
    }
  }, {
    path: '/summary/join_us',
    name: 'SummaryJoinUs',
    component: SummaryJoinUs,
    meta: {
      title: '加入擎科'
    }
  }, {
    path: '/recruit',
    name: 'Recruit',
    component: Recruit,
    meta: {
      title: '招聘详情'
    }
  },     {
    path: '/tec/extraction',
    name: 'Extraction',
    component: Extraction,
    meta: {
      title: '提取扩增测序'
    }
  }, {
    path: '/tec/cell_free',
    name: 'CellFree',
    component: CellFree,
    meta: {
      title: '无细胞蛋白合成系统'
    }
  },  {
    path: '/tec/vector',
    name: 'Vector',
    component: Vector,
    meta: {
      title: '载体构建'
    }
  },  {
    path: '/tec/DNA_barcode',
    name: 'DNABarcode',
    component: DNABarcode,
    meta: {
      title: 'DNA条码检测'
    }
  },   {
    path: '/tec/resequencing',
    name: 'Resequencing',
    component: Resequencing,
    meta: {
      title: '重测序'
    }
  }, {
    path: '/tec/circRNA',
    name: 'CircRNA',
    component: CircRNA,
    meta: {
      title: 'circRNA测序'
    }
  },    {
    path: '/tec/target_sequencing',
    name: 'TargetSequencing',
    component: TargetSequencing,
    meta: {
      title: '目标区域测序'
    }
  },  {
    path: '/tec/de_novo',
    name: 'DeNovo',
    component: DeNovo,
    meta: {
      title: '全基因组de novo测序'
    }
  },
     {
    path: '/intel/T15KL',
    name: 'T15KL',
    component: T15KL,
    meta: {
      title: 'T15KL手持式无线均质仪'
    }
  }, {
    path: '/intel/wh5',
    name: 'Wh5',
    component: Wh5,
    meta: {
      title: 'WH-5 / WH-10水浴锅'
    }
  }, {
    path: '/intel/mp2500',
    name: 'Mp2500',
    component: Mp2500,
    meta: {
      title: 'MP-2500微孔板离心机'
    }
  }, {
    path: '/intel/mc15k',
    name: 'Mc15k',
    component: Mc15k,
    meta: {
      title: 'MC-15K微型高速离心机'
    }
  },  {
    path: '/intel/tm30',
    name: 'Tm30',
    component: Tm30,
    meta: {
      title: 'TM-30转盘混合仪'
    }
  },
    {
    path: '/intel/mini_7ks',
    name: 'Mini7ks',
    component: Mini7ks,
    meta: {
      title: 'Mini-7KS复合转子离心机 '
    }
  }, {
    path: '/intel/RT20',
    name: 'RT20',
    component: RT20,
    meta: {
      title: 'RT-20 3D 混合仪 '
    }
  }, {
    path: '/intel/metal',
    name: 'Metal',
    component: Metal,
    meta: {
      title: 'Mini系列金属浴 '
    }
  }, {
    path: '/intel/MIX2500',
    name: 'MIX2500',
    component: MIX2500,
    meta: {
      title: 'MIX-2500迷你混合仪'
    }
  }, {
    path: '/intel/mini_centrifuge',
    name: 'MiniCentrifuge',
    component: MiniCentrifuge,
    meta: {
      title: '迷你离心机'
    }
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
    meta: {
      show:true,
      title: '生物试剂',
      content: {
        keywords: '合成生物学 基因  引物 测序',
        description: '擎科生物是一家CXO的公司'
      }
    },
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: {
      title: '搜索'
    }
  }, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录'
    }
  }, {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: '注册'
    }
  }, {
    path: '/reset',
    name: 'Reset',
    component: Reset,
    meta: {
      title: '重置密码'
    }
  }, {
    path: '/forget',
    name: 'Forget',
    component: Forget,
    meta: {
      title: '忘记密码'
    }
  }, {
    path: '/account_status',
    name: 'AccountStatus',
    component: AccountStatus,
    meta: {
      title: '账户状态'
    }
  }, {
    path: '/tec/order_sanger',
    name: 'OrderSanger',
    component: OrderSanger,
    meta: {
      title: 'Sanger测序发起取样',
      requireAuth: true
    }
  }, {
    path: '/tec/order_primer',
    name: 'OrderPrimer',
    component: OrderPrimer,
    meta: {
      title: '引物合成在线订购',
      scrollTop: true,
      requireAuth: true
    }
  }, {
    path: '/tec/primer_confirm',
    name: 'PrimerConfirm',
    component: PrimerConfirm,
    meta: {
      title: '引物合成订单确认',
      requireAuth: true
    }
  }, {
    path: '/tec/order_gene',
    name: 'OrderGene',
    component: OrderGene,
    meta: {
      title: '基因合成在线订购',
      requireAuth: true
    }
  }, {
    path: '/tec/gene_confirm',
    name: 'GeneConfirm',
    component: GeneConfirm,
    meta: {
      title: '基因合成订单确认',
      requireAuth: true
    }
  }, {
    path: '/tec/success_submit',
    name: 'SuccessSubmit',
    component: SuccessSubmit,
    meta: {
      title: '订单提交成功',
      requireAuth: true
    }
  }, {
    path: '/products/chart',
    name: 'ProductsChart',
    component: ProductsChart,
    meta: {
      title: '分子产品商城购物车',
      requireAuth: true
    }
  }, {
    path: '/products/chart_confirm',
    name: 'ProductsChartConfirm',
    component: ProductsChartConfirm,
    meta: {
      title: '擎科科邦邦商城订单确认',
      requireAuth: true
    }
  }, {
    path: '/user',
    name: 'User',
    component: User,
    meta: {
      title: '用户中心',
      requireAuth: true
    },
    children: [{
      path: '/user',
      name: 'UserIndex',
      component: UserIndex,
      meta: {
        title: '用户中心',
        requireAuth: true
      }
    }, {
      path: '/user/course',
      name: 'UserCourse',
      component: UserCourse,
      meta: {
        title: '课程组信息',
        requireAuth: true
      }
    }, {
      path: '/user/molecular',
      name: 'UserMolecular',
      component: UserMolecular,
      meta: {
        title: '擎科科邦邦商城订单',
        requireAuth: true
      }
    }, {
      path: '/user/sanger',
      name: 'UserSanger',
      component: UserSanger,
      meta: {
        title: 'Sanger测序订单',
        requireAuth: true
      }
    }, {
      path: '/user/fastNGS',
      name: 'fastNGS',
      component: fastNGS,
      meta: {
        title: 'Fast NGS订单',
        requireAuth: true
      }
    }, {
      path: '/user/sanger_record',
      name: 'UserSangerRecord',
      component: UserSangerRecord,
      meta: {
        title: '测序取样申请记录',
        requireAuth: true
      }
    }, {
      path: '/user/primer',
      name: 'UserPrimer',
      component: UserPrimer,
      meta: {
        title: '引物合成订单',
        requireAuth: true
      }
    }, {
      path: '/user/gene',
      name: 'UserGene',
      component: UserGene,
      meta: {
        title: '基因合成订单',
        requireAuth: true
      }
    }, {
      path: '/user/project',
      name: 'UserProject',
      component: UserProject,
      meta: {
        title: '项目订单',
        requireAuth: true
      }
    }, {
      path: '/user/mall',
      name: 'UserMall',
      component: UserMall,
      meta: {
        title: '积分商城',
        requireAuth: true
      }
    }, {
      path: '/user/integral_get',
      name: 'UserIntegralGet',
      component: UserIntegralGet,
      meta: {
        title: '积分获取记录',
        requireAuth: true
      }
    }, {
      path: '/user/integral_exchange',
      name: 'UserIntegralExchange',
      component: UserIntegralExchange,
      meta: {
        title: '积分兑换记录',
        requireAuth: true
      }
    }, {
      path: '/user/Collection',
      name: 'UserCollection',
      component: UserCollection,
      meta: {
        title: '商品收藏',
        requireAuth: true
      }
    }, {
      path: '/user/comment',
      name: 'UserComment',
      component: UserComment,
      meta: {
        title: '商品评论',
        requireAuth: true
      }
    }, {
      path: '/user/consult',
      name: 'UserConsult',
      component: UserConsult,
      meta: {
        title: '商品咨询',
        requireAuth: true
      }
    }, {
      path: '/user/arrivalNotice',
      name: 'arrivalNotice',
      component: arrivalNotice,
      meta: {
        title: '到货通知',
        requireAuth: true
      }
    }, {
        path: '/user/My_Coupons',
        name: 'My_Coupons',
        component: mycoupon,
        meta: {
          title: '我的优惠券',
          requireAuth: true
        }
      }, {
        path: '/user/Binding_Coupons',
        name: 'Binding_Coupons',
        component: bind,
        meta: {
          title: '绑定优惠券',
          requireAuth: true
        }
      },
    ]
  }, {
    path: '/user/product/details',
    name: 'UserProductDetail',
    component: UserProductDetail,
    meta: {
      title: '商品详情',
      requireAuth: true
    }
  }, {
    path: '/user/order_intergal',
    name: 'OrderIntergal',
    component: OrderIntergal,
    meta: {
      title: '积分兑换订单确认',
      requireAuth: true
    }
  }, {
    path: '/user/project_details',
    name: 'UserProjectDetails',
    component: UserProjectDetails,
    meta: {
      title: '项目订单详情',
      requireAuth: true
    }
  }, {
    path: '/user/sanger_details',
    name: 'UserSangerDetails',
    component: UserSangerDetails,
    meta: {
      title: 'Sanger测序订单详情',
      requireAuth: true
    }
  }, {
    path: '/user/fastNGS_details',
    name: 'fastNGSDetails',
    component: fastNGSDetails,
    meta: {
      title: 'fastNGS订单详情',
      requireAuth: true
    }
  },
  {
    path: '/user/molecular_details',
    name: 'UserMolecularDetails',
    component: UserMolecularDetails,
    meta: {
      title: '分子订单详情',
      requireAuth: true
    }
  }, {
    path: '/user/sanger_search',
    name: 'UserSangerSearch',
    component: UserSangerSearch,
    meta: {
      title: 'Sanger测序反应结果综合查询',
      requireAuth: true
    }
  }, {
    path: '/user/primer_details',
    name: 'UserPrimerDetails',
    component: UserPrimerDetails,
    meta: {
      title: '引物合成订单详情',
      requireAuth: true
    }
  }, {
    path: '/user/gene_details',
    name: 'UserGeneDetails',
    component: UserGeneDetails,
    meta: {
      title: '基因合成订单详情',
      requireAuth: true
    },
  },
  {
    path: '/share/member-auth',
    name: 'MemberAuth',
    component: MemberAuth,
    meta: {
      title: '客户授权',
      isShare: true
    },
  },
  {
    path: '/share/confirm-order',
    name: 'ConfirmOrder',
    component: ConfirmOrder,
    meta: {
      title: '订单详情',
      isShare: true,
    },
  },
  {
    path: '/share/confirm-popup',
    name: 'ConfirmPopup',
    component: ConfirmPopup,
    meta: {
      title: '确认',
      isShare: true
    },
  },
  {
      path: '/dingding-message-pushTip',
      name: 'dingdingMessagePushTip',
      component: messagePushTip,
      meta: {
        title: '详情',
        noShowHeader: true,
        noshowService: true,
    }
  },
  {
    path: '/share/gene-graph',
    name: 'GeneGraph',
    component: GeneGraph,
    meta: {
      title: '订单生产进度列表',
      isShare: true
    },
  },
  {
    path: '/emailLink',
    name: 'emailLink',
    component: EmailLink,
    meta: {
      title: '样品鉴定失败原因分析',
      noShowHeader: true,
      noshowService: true,
    },
  },
  {
    path: '/confirmExchangeSuccess',
    name: 'confirmExchangeSuccess',
    component: confirmExchangeSuccess,
    meta: {
      title: '确认',
      noShowHeader: true,
      noshowService: true,
    },
  },
  {
    path: '/amplificationPrimerDesign',
    name: 'amplificationPrimerDesign',
    component: amplificationPrimerDesign,
    meta: {
      title: '扩增引物设计',
      noShowHeader: true,
      noshowService: true,
    },
  },
  {
    path: '/confirmExchange',
    name: 'confirmExchange',
    component: confirmExchange,
    meta: {
      title: '订单详情',
      requireAuth: true
    }
  },
  {
    path: '/ImproveInformation',
    name: 'ImproveInformation',
    component: ImproveInformation,
    meta: {
      title: '完善信息',
      noShowHeader: true,
      noshowService: true,
    },
  },
  // {
  //   path: '/user/primer_search',
  //   name: 'UserPrimerSearch',
  //   component: UserPrimerSearch,
  //   meta: {
  //     title: '引物合成反应结果综合查询',
  //     requireAuth: true
  //   }
  // },
  ...toolRoutes,
  ...mobileRoutes
]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    console.info(to)
    if (!to.meta.scrollTop) {
      return savedPosition;
    } else {
      return {x: 0, y: 0}
    }
  }
})

router.beforeEach((to, from, next) => {
  if((to.path != '/molecular-reagent' && !to.path.includes('/summary/')) || (to.name=='SummaryAbout' && from.name=="Index")){
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
  setTitle.title(to.meta.title)
  // 加入权限判断
  const userInfo = baseMethods.getLocalObj('userInfo')
  // if (to.matched.some(r => r.meta.requireAuth)) {
    var url = decodeURIComponent(window.location.search)
    //token缓存存在
    if (userInfo && userInfo.token && url.indexOf('sign')>-1) {
      const sign = baseMethods.getLocalStr('url')
      //比较的sign相同
      if(sign && sign === url) {
        next()
        //比较的sign不相同
      }else {
        console.log("比较的sign不相同")
        localStorage.clear()
        localStorage.removeItem('userInfo')
       // Loading.service({ fullscreen: true });
        Axios.get(`/web/user/customer-users/login/shop${url}`).then(async res => {
          if(res.data.token) {
            await baseMethods.setLocalObj('userInfo', res.data)
            baseMethods.setLocalStr('url',url)
            await store.dispatch('memberInfo')
            await store.dispatch('courseInfo')
            loginShopDelete(url.split("=")[1])
            let loadingInstance = Loading.service();
            loadingInstance.close();
            next()
          }else {
            Loading.service().close();
            next()
          }
        })
      }
      // token缓存不存在
    } else if(url.indexOf('sign')>-1){
      if (to.meta.isMobile) {
        // router.replace('/mobile/login')
      } else {
        Loading.service({background:'#fff', body: true});
        //请求token
        Axios.get(`/web/user/customer-users/login/shop${url}`).then(async res => {
          if(res.data.token) {
            await baseMethods.setLocalObj('userInfo', res.data)
            baseMethods.setLocalStr('url',url)
            await store.dispatch('memberInfo')
            await store.dispatch('courseInfo')
            loginShopDelete(url.split("=")[1])

            const redirectUrlTsMatch = url.match(/redirectUrlTs=([^&]+)/);
            if (redirectUrlTsMatch && redirectUrlTsMatch[1] && redirectUrlTsMatch[1].includes('https://')) {
              getAuthCode().then((backRes)=>{
                let urlPlicing = ''
                if(redirectUrlTsMatch[1].includes('?')){
                 if(redirectUrlTsMatch[1].includes('app_id=tsingke_official')){
                    urlPlicing=`${redirectUrlTsMatch[1]}&auth_code=${backRes.data}`
                  }else{
                    urlPlicing=`${redirectUrlTsMatch[1]}&auth_code=${backRes.data}&app_id=tsingke_official`
                  }

                }else{
                  if(redirectUrlTsMatch[1].includes('app_id=tsingke_official')){
                    urlPlicing=`${redirectUrlTsMatch[1]}?auth_code=${backRes.data}`
                  }else{
                    urlPlicing=`${redirectUrlTsMatch[1]}?auth_code=${backRes.data}&app_id=tsingke_official`
                  }

                }
                console.log(urlPlicing)
                window.location = urlPlicing
              })
            }else{
              let loadingInstance = Loading.service();
              loadingInstance.close();
              next()
            }
          }else {
            Loading.service().close();
            next()
          }
        })
      }
    }else if(to.path.includes("/tools") && from.path!=="/tools"){
      if(userInfo && userInfo.token) {
        next()
      }
    } else {
      next()
    }
})

router.afterEach((to, from) => {
  if(baseMethods.getLocalObj('memberInfo')) {
    store.dispatch('updateAgreementAction')
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js